export const FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'clientName',
    inputAdornment: '',
    label: 'Nombre completo',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'phone',
    inputAdornment: '',
    label: 'Teléfono',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresar 9 dígitos',
  },
  {
    name: 'email',
    inputAdornment: '',
    label: 'Correo',
    textArea: '',
    disabled: false,
    required: true,
  },
  {
    name: 'giftCardNumber',
    inputAdornment: '',
    label: 'Nº de Gift Card',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Ingresa 7 o 20 dígitos',
  },
  {
    name: 'comment',
    inputAdornment: '',
    label: 'Escribir comentario',
    textArea: '4',
    disabled: false,
    required: false,
    rows: 4,
    multiline: true,
  },
];
